import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { Building2, LogOut } from "lucide-react";
import { getUser, logout } from "@/utils/auth";
import { Button } from "@/components/ui/button";

const SuperuserLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = getUser();

  return (
    <div className="flex h-screen bg-zinc-50">
      
      {/* Sidebar */}
      <aside className="w-64 bg-zinc-900 text-white flex flex-col">
        <div className="p-6 border-b border-zinc-800 flex items-center gap-3">
          <img src="/logo192.png" alt="IronPulse" className="h-8 w-8 object-contain" />
          <div>
            <h1 className="text-2xl font-black tracking-tight" style={{ fontFamily: 'Chivo, sans-serif' }}>
              <span className="text-lime-400">Super</span>Admin
            </h1>
            <p className="text-xs text-zinc-400 mt-1">SYSTEM MANAGER</p>
          </div>
        </div>

        <nav className="flex-1 p-4 space-y-1">
          <button
            onClick={() => navigate("/superuser/dashboard")}
            className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all ${
              location.pathname === "/superuser/dashboard"
                ? "bg-lime-400 text-zinc-900 font-bold"
                : "text-zinc-400 hover:bg-zinc-800 hover:text-white"
            }`}
          >
            <Building2 size={20} />
            <span>Companys</span>
          </button>
        </nav>

        {/* User Info & Logout */}
        <div className="p-4 border-t border-zinc-800">
          <div className="mb-3 p-3 bg-zinc-800 rounded-lg">
            <p className="text-sm font-bold text-white">{user?.full_name}</p>
            <p className="text-xs text-zinc-400 truncate">{user?.email}</p>
            <p className="text-xs text-red-400 mt-1">SUPERUSER</p>
          </div>
          <Button
            onClick={logout}
            variant="outline"
            className="w-full bg-transparent border-zinc-700 text-zinc-300 hover:bg-zinc-800 hover:text-white"
          >
            <LogOut size={16} className="mr-2" />
            Logout
          </Button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 overflow-auto">
        <div className="p-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default SuperuserLayout;
